// extracted by mini-css-extract-plugin
export var formContainer = "_j6-0";
export var message = "_j6-1";